// Module
var code = `<breadcrumbs></breadcrumbs>
<customer-profile-header  ng-if="\$ctrl.customerId"></customer-profile-header>
<section class="box">
  <sub-header header="\$ctrl.title"></sub-header>

  <table class="table table--last-column-to-right">
    <thead>
    <tr>
      <th>No</th>
      <th>Report Name</th>
      <th>Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="report in \$ctrl.reports" class="report-list-row">
      <td>{{(\$index + 1) + '.'}}</td>
      <td>{{report.name}}</td>
      <td>
        <a ng-href="{{\$ctrl.openLink(report)}}" class="btn btn-primary">
          Open
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/report-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;